import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import { BooleanField, Datagrid, EditButton, List, ListActions, ShowButton, SimpleList, TextField } from "react-admin";
import { EmptyList } from "server/components";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { CoursesExporter } from "./XlsxExporter";
import { MobileListRow } from "features/MobileListRow";

const ListCourses = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();
  
  return (
    <List
      exporter={CoursesExporter}
      title="Курсове"
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreatePreparatoryCourses)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Активен курс",
                    value: (
                      <BooleanField
                        source="isActive"
                        label="Активен курс"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(getPermissions(), permissions.canUpdatePreparatoryCourses) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <BooleanField
            source="isActive"
            label="Активен курс"
          />
          <SecuredComponent permission={permissions.canUpdatePreparatoryCourses}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListCourses;
